import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=0125f96e&scoped=true&"
import script from "./Birthday.vue?vue&type=script&lang=js&"
export * from "./Birthday.vue?vue&type=script&lang=js&"
import style0 from "./Birthday.vue?vue&type=style&index=0&id=0125f96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125f96e",
  null
  
)

export default component.exports